import React from "react";
import Home from "./home";
import Header from "./header";
import { Test } from "./test";
import Footer from "./footer";
import './photo.css'





export default function PhotoSite() {
    return(
        <div>
            <Header/>
            <Home/>
            <Test/>
            {/* <Test2/> */}
            <Footer/>
        </div>
    )
}